<template>
  <ts-input class="ts-search-bar" size="mini" prefix-icon="el-icon-search" v-bind="$attrs" v-on="$listeners"></ts-input>
</template>

<style lang="scss" scoped>
.ts-search-bar::v-deep {
  .el-input__inner {
    padding-left: 26px !important;
  }
  .el-input__icon {
    color: #6d7587;
  }
}
</style>

<script>
export default {
  name: 'TsSearchBar'
};
</script>
